import type { PasswordChangeDto, PasswordChangedDto, UserProfileDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';

/** E04 — GET /users/me */
export async function getMe(): Promise<UserProfileDto> {
  const { data } = await apiClient.get<UserProfileDto>('/users/me');
  return data;
}

/** E33 — POST /users/me/password. Returns a fresh access token for the caller's own session. */
export async function postChangePassword(body: PasswordChangeDto): Promise<PasswordChangedDto> {
  const { data } = await apiClient.post<PasswordChangedDto>('/users/me/password', body);
  return data;
}
